"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Attachment = function Attachment(api, data) {
  (0, _classCallCheck3.default)(this, Attachment);

  Object.assign(this, (0, _extends3.default)({ api: api }, data));
};

Attachment._namespace = "attachments";

Attachment.getAttachments = function (api, phraseId) {
  return api.getCollection(Attachment, "phrases/" + phraseId + "/attachments");
};

Attachment.newAttachment = function (api, phraseId, data) {
  // eslint-disable-next-line no-undef
  var payload = new FormData();
  Object.keys(data).forEach(function (field) {
    return payload.append(field, data[field]);
  });
  return api.postObject(Attachment, "phrases/" + phraseId + "/attachments", payload);
};

Attachment.getAttachment = function (api, phraseId, id) {
  return api.getObject(Attachment, "phrases/" + phraseId + "/attachments/" + id);
};

Attachment.deleteAttachment = function (api, phraseId, id) {
  return api.deleteObject(Attachment, "phrases/" + phraseId + "/attachments", id);
};

exports.default = Attachment;


//////////////////
// WEBPACK FOOTER
// ../sdk/lib/Attachment.js
// module id = 317
// module chunks = 0